module.exports = __webpack_public_path__ + "img/fancy.1177b83.webp";